<nz-card [nzTitle]="label" [nzExtra]="toggleSwitch">
	<ng-container *ngIf="isActive && canSeeGroups$ | async">
		<h3>{{ 'user.editroles.groups' | translate }}</h3>
		<nz-select nzMode="multiple" class="group-select"
				[(ngModel)]="selectedGroups"
				(ngModelChange)="changedGroups$.next($event)"
				[nzDisabled]="(canEditGroups$ | async) === false"
		>
			<nz-option *ngFor="let group of projectGroups$ | async"
					[nzLabel]="group.name" [nzValue]="group.id"
					[nzDisabled]="(disabledGroups$ | async)[group.id]"
			></nz-option>
		</nz-select>
	</ng-container>
	<ng-container *ngIf="canSeeRoles && projectUser$ | async as projectUser">
		<h3>{{ 'user.editroles.roles' | translate }}</h3>
		<table>
			<tbody>
				<tr *ngFor="let projectRole of projectRoles$ | async; trackBy: roleTrackBy">
					<ng-container *ngIf="!projectRole.hidden && { enabled: projectUser.roles.includes(projectRole.rolename), loading: false } as state">
						<td class="cell-padding">
							<nz-switch
								[(ngModel)]="state.enabled" [nzControl]="true" [nzLoading]="state.loading" [disabled]="!canEditRoles"
								(click)="setProjectRole(projectRole, !state.enabled, state)"
							></nz-switch>
						</td>
						<td class="font-weight-bold cell-padding">
							{{ projectRole.label }}
						</td>
						<td class="cell-padding roleDescription">
							{{ projectRole.description }}
						</td>
					</ng-container>
				</tr>
				<tr *ngFor="let globalRole of globalRoles$ | async; trackBy: roleTrackBy">
					<ng-container *ngIf="!globalRole.hidden && globalRole.rolename && { enabled: projectUser.roles.includes(globalRole.rolename), loading: false } as state">
						<td class="cell-padding">
							<nz-switch
									[(ngModel)]="state.enabled" [nzControl]="true" [nzLoading]="state.loading" [disabled]="!canEditRoles"
									(click)="setGlobalRole(globalRole.rolename, !state.enabled, state)"
							></nz-switch>
						</td>
						<td class="font-weight-bold cell-padding">
							{{ globalRole.label }}
						</td>
						<td class="cell-padding roleDescription">
							{{ globalRole.description }}
						</td>
					</ng-container>
				</tr>
			</tbody>
		</table>
	</ng-container>
	<div *ngIf="!isActive && !useGlobalRoles">
		<p>
			{{ 'message.info.projectrole.notassigned' | translate }}
		</p>
		<p [hidden]="!canAssign">
			<button *ngIf="{loading: false} as state" nz-button nzType="primary" (click)="toggleProjectUser(state)" [nzLoading]="state.loading">
				{{ 'form.submit.assign' | translate }}
			</button>
		</p>
	</div>
	<div *ngIf="isActive && !canSeeRoles">
		<p>
			{{ 'message.info.projectrole.notpermitted' | translate }}
		</p>
	</div>
</nz-card>

<ng-template #toggleSwitch>
	<span *ngIf="!useGlobalRoles && isActive" class="mr-2 zugeordnet-tag">Zugeordnet</span>
	<nz-switch [hidden]="!canAssign" *ngIf="!useGlobalRoles && {loading: false} as state"
		[(ngModel)]="isActive" [nzControl]="true" [nzLoading]="state.loading" [nzDisabled]="isToggleDisabled"
		(click)="toggleProjectUser(state)"
	></nz-switch>
</ng-template>
